import { action, observable, runInAction } from 'mobx';

import { BusyStore } from 'ui/base/button';
import { BooleanStore } from 'ui/base/input';
import { ModalStore } from 'ui/base/modal/modal_store';
import { BandwidthStore } from 'ui/standard/input/bandwidth_input/bandwidth_store';

import { ResultKind } from 'services/base/types';
import { IAccountsDomain, Pangolin } from 'services/accounts/types';
import * as PangolinService from 'services/accounts/pangolin_service';

export class BandwidthSettingsStore {
  private readonly pangolin: Pangolin;

  upload: BandwidthStore;
  download: BandwidthStore;
  enableBandwidthControls: BooleanStore;
  enableBufferbloatPrevention: BooleanStore;

  bandwidthControlsModal: ModalStore;
  bufferbloatPreventionModal: ModalStore;

  @observable.ref
  bandwidthUploadStringError?: string;

  @observable.ref
  bandwidthDownloadStringError?: string;

  @observable.ref
  busy: BusyStore;

  constructor(pangolin: Pangolin) {
    this.pangolin = pangolin;

    this.upload = new BandwidthStore(
      pangolin.bandwidthUploadString ?? '',
      pangolin.bandwidthUploadUnits,
    );
    this.download = new BandwidthStore(
      pangolin.bandwidthDownloadString ?? '',
      pangolin.bandwidthDownloadUnits,
    );
    this.enableBandwidthControls = new BooleanStore(pangolin.enableBandwidthControls);
    this.enableBufferbloatPrevention = new BooleanStore(pangolin.enableBufferbloatPrevention);

    this.bandwidthControlsModal = new ModalStore(false);
    this.bufferbloatPreventionModal = new ModalStore(false);

    this.busy = new BusyStore();
  }

  @action.bound
  async handleSave(accounts: IAccountsDomain): Promise<PangolinService.UpdatePangolinResult> {
    if (accounts.pangolins.has(this.pangolin.id)) {
      const result = await PangolinService.update({
        domain: accounts,
        id: this.pangolin.id,
        bandwidthUploadString: this.upload.string.value,
        bandwidthUploadUnits: this.upload.unit.value,
        bandwidthDownloadString: this.download.string.value,
        bandwidthDownloadUnits: this.download.unit.value,
        enableBandwidthControls: this.enableBandwidthControls.value,
        enableBufferbloatPrevention: this.enableBufferbloatPrevention.value,
      });

      return runInAction(() => {
        if (result.kind === ResultKind.USER_ERROR) {
          this.bandwidthUploadStringError = result.bandwidthUploadStringError;
          this.bandwidthDownloadStringError = result.bandwidthDownloadStringError;
        }
        return result;
      });
    }

    return { kind: ResultKind.SYSTEM_ERROR };
  }
}
